import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { WidgetTypes } from '@src/helpers/Enums';
import I18n from '@src/i18n';
import { Popover } from 'antd';
import React from 'react';

import AditionalContent from './AditionalContent';
import { PopoverContainer, WidgetBox } from './styles';



type PropType = {
  data: any;
  title: string;
  id: any;
  unit: any;
  widgetID: string;
  deleteWidgetByIndex: Function;
  editWidget?: Function;
  isPreview?: boolean;
  widget?: any;
  duplicateWidget: Function;
}


function deleteWidget(props: any) {
  props.deleteWidgetByIndex(props.id, props.widgetID)
}


function groupByComp(data: any, widget?: boolean) {
  let components: any = [];
  if(data && data.length > 0){
    data.filter(e => e.components).forEach(e => {
      e.components.forEach(c => {
        if (Array.isArray(c.value)) {
          components = components.concat(c.value);
        }
        else {
          components.push(c.value);
        }
      })
    });
  }
  let labels = components.filter((e, i) => components.indexOf(e) == i).sort();
  labels = labels.filter(e => e)
  let result = {
    labels: labels
    , data: []
  };
  labels.forEach(l => {
    if(widget && widget.recurrence){
      result.data.push(components.filter(e => e == l).length - 1);  
    } else {
    result.data.push(components.filter(e => e == l).length);
    }
  })
  
  
  return result;
}

function duplicateWidget(props: any){
  props.duplicateWidget();
}

function formattedValues(groupedValues: any) {
  let mappedarray = []
  for (let i = 0; i < groupedValues.labels.length; i++) {
    mappedarray.push({ labels: groupedValues.labels[i], data: groupedValues.data[i] })
  }
  mappedarray = mappedarray.sort((a, b) => (a.data > b.data) ? -1 : 1)
  return mappedarray
}


function editWidget(props: any) {
  props.editWidget()
}

function popoverContent(props: any) {
  return (
    <PopoverContainer>
    <div style={{ display: 'flex' }} className="popover-row" onClick={() => editWidget(props)} >
      <div className="icon">
        <FontAwesomeIcon icon={'edit'} />
      </div>
      <div className="text">
        <p>{I18n.l('common.edit')}</p>
      </div>
    </div>

    <div style={{ display: 'flex' }} className="popover-row" onClick={() => duplicateWidget(props)}>
      <div className="icon">
        <FontAwesomeIcon icon={'clone'} />
      </div>
      <div className="text">
        <p>{I18n.l('common.duplicate')}</p>
      </div>
    </div>

    <div style={{ display: 'flex' }} className="popover-row" onClick={() => deleteWidget(props)}>
      <div className="icon">
        <FontAwesomeIcon icon={'trash'} />
      </div>
      <div className="text">
        <p>{I18n.l('common.delete')}</p>
      </div>
    </div>
  </PopoverContainer>
  )

}

const verifyIsUrl = function (str: string) {
  const regex = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim
  const doMatch = str.match(regex)

  return doMatch
}

const List = (props: PropType) => {
  const groupedValues = groupByComp(props.data, props.widget)
  const data = formattedValues(groupedValues)
  return (
    <WidgetBox className={`-list ${props.isPreview ? "-preview" : ''}`}>
      <div className="up">
        <div className="title">
          {props.title}
        </div>
        <div className="edit custom"  >
          {!props.isPreview &&
            <div className="please-disapear no-padding">
              <Popover
                placement='bottom'
                trigger="hover"
                content={popoverContent(props)}
              >
                <FontAwesomeIcon icon={"cog"} />
              </Popover>
            </div>
          }
        </div>
      </div>
      <div className="bottom">
      {data.length === 0 &&
          <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <h1 style={{fontWeight: 400}}>{I18n.l('dashboard.noData')}</h1>
          </div>
      }
        {data && data.length > 0 && 
        <div className="table-container">
          <table>
            <tbody>
            {data.map((singleData) =>
              <tr key={singleData.labels}>
                {
              typeof singleData.labels === 'string' &&
              <>
                <td>{singleData.data}</td>
                <td>
                  {verifyIsUrl(singleData.labels) && (<a href={singleData.labels} target="_blank">{singleData.labels}</a>)}
                  {!verifyIsUrl(singleData.labels) && singleData.labels}
                </td>
              </>
              }
              {typeof singleData.labels === 'object' &&
              <>
                <td>{singleData.labels.score}</td>
                <td>{singleData.labels.result}</td>
              </>}
              </tr>)}
              </tbody>
          </table>
        </div>}
        <AditionalContent type={WidgetTypes.LIST} widget={props.widget} count={data ? data.length : 0} />
      </div>
    </WidgetBox>
  )
}

export default List

